import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'When will the 2026 gTLD application round open?',
    answer: 'ICANN has announced that the next round of new gTLD applications will open April 30, 2026 and the application window will be open for 105 days and close on August 12, 2026. Organizations may want to start preparing now to ensure they are ready when applications open.'
  }, {
    question: 'What is a gTLD?',
    answer: 'A generic Top-Level Domain (gTLD) is the extension that appears at the end of a domain name, such as .com, .org, or .net. New gTLDs expand beyond these traditional options, allowing for more specific and branded extensions.'
  }, {
    question: 'How is the 2026 round different from the 2012 round?',
    answer: <>
          The 2026 round introduces several important changes:
          <ul className="list-disc list-inside mt-3 space-y-3" data-id="element-92">
            <li data-id="element-93">
              <strong data-id="element-94">Costs</strong> – Application fees are higher, and
              available refunds are lower than in 2012.
            </li>
            <li data-id="element-95">
              <strong data-id="element-96">No Private Resolution</strong> – Private resolution of
              applications in contention is prohibited in the 2026 round.
              However, certain private resolution options are available before
              Reveal Day, including potentially by auction. Contact us to learn
              more about these options.
            </li>
            <li data-id="element-97">
              <strong data-id="element-98">Alternate Strings</strong> – Applicants can now include an
              alternate string in their application. If the primary string is in
              contention, the applicant may be able to change to the alternate
              string to avoid contention.
            </li>
            <li data-id="element-99">
              <strong data-id="element-100">Approved Registry Service Providers (RSPs)</strong> –
              Companies providing backend infrastructure must be approved by
              ICANN in the 2026 round. Applicants are required to use an
              approved RSP, even if they plan to operate the infrastructure
              themselves.
            </li>
          </ul>
        </>
  }, {
    question: 'How much will it cost to apply in the 2026 round?',
    answer: "The application fee for the 2026 round is $227,000 USD. This evaluation fee is non-refundable and covers ICANN's cost of processing and evaluating your application. Additional costs include technical infrastructure, legal fees, and ongoing operational expenses. The total investment typically ranges from $500,000 to several million dollars depending on your approach."
  }, {
    question: 'How long does the application process take?',
    answer: 'Based on the 2012 round, the entire process from application to delegation typically takes 9-24 months, depending on various factors including whether there are competing applications for the same string, objections filed, or other complications. The 2026 round may feature improved timelines.'
  }, {
    question: 'Can any organization apply for a gTLD in 2026?',
    answer: "Yes, any established organization can apply for a gTLD, provided they meet ICANN's technical, operational, and financial requirements. Applicants must demonstrate the capability to operate a registry according to ICANN standards."
  }, {
    question: 'Should I start preparing now for the 2026 round?',
    answer: 'Absolutely! Early preparation is crucial to enhance the likelihood of a successful gTLD application. You may want to start now by researching your desired string, assembling your team, understanding technical requirements, securing funding, and developing your business plan. The preparation phase can take 12-18 months or more.'
  }, {
    question: 'What are the technical requirements for operating a gTLD?',
    answer: 'Operating a gTLD requires robust technical infrastructure including DNS servers, registry systems, data escrow, and DNSSEC implementation. Most applicants partner with established registry service providers who have the necessary technical expertise and infrastructure.'
  }];
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="py-20 bg-white" data-id="element-101">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
        <div className="text-center mb-16" data-id="element-103">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1E1D14] mb-6 font-serif" data-id="element-104">
            Frequently Asked Questions
          </h2>
          <div className="w-24 h-1 bg-[#C4A44A] mx-auto mb-6" data-id="element-105"></div>
          <p className="text-xl text-[#5A5535] font-light" data-id="element-106">
            Find answers to common questions about the 2026 gTLD application
            round.
          </p>
        </div>

        <div className="space-y-4" data-id="element-107">
          {faqs.map((faq, index) => <div key={index} className={`bg-[#FAF9F5] rounded-sm border transition-all duration-300 ${openIndex === index ? 'border-[#C4A44A] shadow-md' : 'border-[#EDE9DB]'}`} data-id="element-108">
              <button className="w-full text-left px-8 py-6 flex justify-between items-center focus:outline-none" onClick={() => toggleFaq(index)} data-id="element-109">
                <h3 className={`text-lg font-bold font-serif ${openIndex === index ? 'text-[#1E1D14]' : 'text-[#1E1D14]'}`} data-id="element-110">
                  {faq.question}
                </h3>
                {openIndex === index ? <ChevronUpIcon className="h-5 w-5 text-[#C4A44A]" data-id="element-111" /> : <ChevronDownIcon className="h-5 w-5 text-[#5A5535]" data-id="element-112" />}
              </button>
              <div className={`px-8 pb-6 ${openIndex === index ? 'block' : 'hidden'}`} data-id="element-113">
                <div className="text-[#3D3A25] leading-relaxed border-t border-[#EDE9DB] pt-4" data-id="element-114">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-115">
          <p className="text-[#3D3A25] mb-6 font-light" data-id="element-116">
            Still have questions about the 2026 gTLD application process?
          </p>
          <a href="#contact" className="inline-flex items-center px-8 py-4 border border-transparent text-sm font-bold uppercase tracking-wider rounded-sm shadow-sm text-white bg-[#5A5535] hover:bg-[#3D3A25] transition-colors" data-id="element-117">
            Contact Our Team
          </a>
        </div>
      </div>
    </section>;
};